module.exports = __webpack_public_path__ + "img/figure-23.d971608b.png";